import { connect } from "react-redux";
import SquareItem from "./SquareItem";
import { getCountryCode } from "@template/state/modules/regionalStore";

function mapStateToProps(state) {
  return {
    countryCode: getCountryCode(state)
  };
}

export default connect(mapStateToProps)(SquareItem);
